import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useBusiness } from '@/hooks/useBusiness';
import { Arrow } from '@/icons/index';

import styles from './styles.module.scss';

const Language = ({ className }) => {
  const { asPath, locale, locales } = useRouter();
  const isBusiness = useBusiness();

  const renderLanguage = (item, index) => {
    if (item === locale) {
      return (
        <span className={styles.active} key={index}>
          {item?.toUpperCase()}
        </span>
      );
    }
    return (
      <Link href={asPath} locale={item} key={index}>
        <a>{item?.toUpperCase()}</a>
      </Link>
    );
  };
  const filterLocales = locales?.filter((item) => item !== locale);

  return (
    <div
      className={classNames(styles.container, className)}
      itemScope
      itemType='https://schema.org/Property'
    >
      <span className={styles.current}>{locale?.toUpperCase()}</span>
      <Arrow width={16} />
      <div
        className={classNames(styles.languageList, {
          [styles.business]: isBusiness,
        })}
      >
        {filterLocales?.map(renderLanguage)}
      </div>
    </div>
  );
};

export default Language;
